<template>
  <div>
    <div v-if="!!sources.length" class="d-flex overflow-auto pb-2">
      <CodePromotionItem 
        v-for="promotion in sources" 
        :key="promotion?.id" 
        :data="promotion?.id ? promotion : {}"
        :user-codes="userCodes"
        @ok="handleCreateCode"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, watch, reactive, ref } from 'vue'
import { useI18n } from "vue-i18n"
import { ElLoading } from 'element-plus'
import { notificationErrors } from "../../utils"
import { _api_getAccountPromotionCodes, _api_postAccountPromotionCodes, _api_getPromotions } from "../../api";
import CodePromotionItem from "../promotions/CodePromotionItem.vue"

const props = defineProps({
  data: { type: Object, required: true },
  storeData: { type: Object, required: true },
  loading: { type: Boolean, default: false },
  is_login: { type: Boolean, default: false },
  sources: { type: Array, default: () => [] },
})

const { t, locale } = useI18n()
const storeId = computed(() => props.storeData?.follow_store_id || props.storeData?.id)
const ids = computed(() => props.data?.store_prom_ids || [])

const userCodes = ref([])
const codePromotions = ref([])
// const format = "YYYY/MM/DD"
const handleErrors = (err) => {
  notificationErrors(err)
}
const getUserCodes = async () => {
  try {
    // return
    const resp = await _api_getAccountPromotionCodes({ limit: 200 })
    const codes = resp.data.data
    if (!!codes.length) {
      userCodes.value = codes.map((el) => el?.store_prom_id)
    }
  } catch (error) {
    handleErrors(error)
  }
}
const getDatas = async () => {
  window.ElFullPageLoading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.5)',
  });
  try {
    const params = {
      fields: 'banner_media',
      ids: ids.value.join(","),
    }
    const resp = await _api_getPromotions(params)
    // console.debug("_api_getPromotions", resp)
    codePromotions.value = resp.data
    
  } catch (error) {
    handleErrors(error)
  } finally {
    window.ElFullPageLoading && window.ElFullPageLoading.close();
  }
}
const handleCreateCode = async (item) => {
  try {
    if (!!item.codes) {
      const resp = await _api_postAccountPromotionCodes({ code: item.codes[0], action: 'get_or_create' })
      // savePromotionCode
      const eventID = resp?.headers?.["x-request-id"] ? resp?.headers?.["x-request-id"] : null
      initTracker(item, eventID)
      getUserCodes()
      swal.fire({
				title: '成功領取折扣碼',
				type: 'success',
				showCancelButton: true,
				confirmButtonColor: 'var(--secondary_color)',
				confirmButtonText: t("carts.continueShopping2"),
				cancelButtonColor: 'var(--primary_color)',
				cancelButtonText: '我的折扣碼',
			}).then((result) => {
				// console.log('result', result);
				if (result.value) {
					// console.log('繼續購物');
				} else if (result.dismiss == "cancel") {
					// console.log('我的折扣碼');
					window.location.href = "/account/promotion-codes";
				}
			})
    }
  } catch (error) {
    handleErrors(error?.response?.data)
  }
}

const initTracker = (promotion = [], eventID = null) => {
  aibTrackers.savePromotionCode(promotion, eventID)
  gtmTrackers.savePromotionCode(promotion, eventID)
  fbqTrackers.savePromotionCode(promotion, eventID)
  ttqTrackers.savePromotionCode(promotion, eventID)
  gtagTrackers.savePromotionCode(promotion, eventID)
  lineAdsTrackers.createEvent('GenerateLead', {}, eventID)
}

watch(
  () => props.is_login,
  (v) => {
    if (v) {
      getUserCodes()
    }
  },
  { deep: false, immediate: true }
)
watch(
  () => ids.value,
  (v) => {
    // console.log("store_product_ids: ", v)
    if (v.length) {
      // getDatas()
    }
  },
  { deep: true, immediate: true }
)
</script>